// Configuración para tamaños Desktop
export const grandeConfig = [
    [
        { io: true, r: 4 },
        { io: false, r: -2 },
        { io: false, r: 0 },
        { io: false, r: 2 },
        { io: false, r: -4 },
    ],
    [
        { io: false, r: 0 },
        { io: false, r: 4 },
        { io: true, r: -2 },
        { io: false, r: -4 },
        { io: false, r: 2 },
    ],
    [
        { io: false, r: -2 },
        { io: false, r: 0 },
        { io: false, r: 4 },
        { io: false, r: 2 },
        { io: true, r: -4 },
    ],
    [
        { io: false, r: -4 },
        { io: false, r: 2 },
        { io: true, r: 0 },
        { io: false, r: -2 },
        { io: false, r: 4 },
    ],
    [
        { io: true, r: 2 },
        { io: false, r: -4 },
        { io: false, r: -2 },
        { io: false, r: 4 },
        { io: false, r: 0 },
    ],
    [
        { io: false, r: -4 },
        { io: false, r: 2 },
        { io: true, r: 4 },
        { io: false, r: 0 },
        { io: false, r: -2 },
    ],
    [
        { io: false, r: 4 },
        { io: false, r: -2 },
        { io: false, r: 0 },
        { io: false, r: 2 },
        { io: true, r: -4 },
    ],
    [
        { io: false, r: 0 },
        { io: false, r: 4 },
        { io: true, r: -2 },
        { io: false, r: -4 },
        { io: false, r: 2 },
    ],
    [
        { io: true, r: -2 },
        { io: false, r: 0 },
        { io: false, r: 4 },
        { io: false, r: 2 },
        { io: false, r: -4 },
    ],
    [
        { io: false, r: -4 },
        { io: false, r: 2 },
        { io: true, r: 0 },
        { io: false, r: -2 },
        { io: false, r: 4 },
    ],
    [
        { io: false, r: 2 },
        { io: false, r: -4 },
        { io: false, r: -2 },
        { io: false, r: 4 },
        { io: true, r: 0 },
    ],
    [
        { io: false, r: -4 },
        { io: false, r: 2 },
        { io: true, r: 4 },
        { io: false, r: 0 },
        { io: false, r: -2 },
    ],
];

// Configuración para tamaño Tablet
export const tabletConfig = [
    [
        { io: true, r: 4 },
        { io: false, r: -2 },
        { io: false, r: 0 },
        { io: false, r: 2 },
        { io: false, r: -4 },
    ],
    [
        { io: false, r: -2 },
        { io: true, r: 4 },
        { io: false, r: 0 },
        { io: false, r: -4 },
        { io: false, r: 2 },
    ],
    [
        { io: false, r: 0 },
        { io: false, r: -4 },
        { io: false, r: 2 },
        { io: true, r: 4 },
        { io: false, r: -2 },
    ],
    [
        { io: false, r: 2 },
        { io: false, r: 0 },
        { io: false, r: -4 },
        { io: false, r: -2 },
        { io: true, r: 4 },
    ],
    [
        { io: false, r: -4 },
        { io: false, r: 2 },
        { io: false, r: 0 },
        { io: true, r: 4 },
        { io: false, r: -2 },
    ],
    [
        { io: false, r: 0 },
        { io: true, r: 4 },
        { io: false, r: -2 },
        { io: false, r: 2 },
        { io: false, r: -4 },
    ],
    [
        { io: true, r: 4 },
        { io: false, r: -2 },
        { io: false, r: 0 },
        { io: false, r: 2 },
        { io: false, r: -4 },
    ],
];

// Tipos para documentación y ayuda al desarrollo
/**
 * @typedef {Object} CardConfig
 * @property {boolean} io - Initial Open state
 * @property {number} r - Rotation angle
 */

/**
 * @typedef {CardConfig[]} ConfigSet
 */

/**
 * Función helper para obtener configuración según tamaño y picks
 * @param {string} size - Tamaño del dispositivo
 * @param {number} cardCount - Número de tarjetas
 * @param {number} groupPick12 - Pick para tamaños desktop (1-12)
 * @param {number} groupPick7 - Pick para tamaño tablet (1-7)
 * @returns {CardConfig[]} Configuración de tarjetas
 */
export const getConfig = (size, cardCount, groupPick12, groupPick7) => {
    if (size === "Phone") {
        return Array(cardCount).fill({ io: true, r: 0 });
    }

    let config;
    if (size === "Desktop 1440" || size === "Desktop 1200") {
        config = grandeConfig[groupPick12 - 1] || grandeConfig[0];
    } else if (size === "Tablet") {
        config = tabletConfig[groupPick7 - 1] || tabletConfig[0];
    } else {
        config = Array(cardCount).fill({ io: true, r: 0 });
    }

    return config.slice(0, cardCount);
};